import PropTypes from 'prop-types'
import React from 'react'
import { FormattedNumber } from 'react-intl'

import {
    sendHoverSoundCommand,
    sendSelectClickSoundCommand,
} from 'react-wot-bootstrap'

import { digitsOnlyKeyDownValidation } from 'containers/WGCWXShop/helpers'

import { KEY_CODES } from 'constants'

import styles from './TankAuctionSlider.scss'

export default class TankAuctionSlider extends React.Component {
    static propTypes = {
        minValue: PropTypes.number.isRequired,
        maxValue: PropTypes.number.isRequired,
        currentValue: PropTypes.number.isRequired,
        handleChange: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            value: props.currentValue,
        }
    }

    componentDidUpdate(oldProps) {
        if (oldProps.currentValue !== this.props.currentValue) this.updateInput()
    }

    handleSliderChange = event => {
        this.props.handleChange(parseInt(event.target.value))
    }

    updateInput = () => this.setState({ value: this.props.currentValue })

    handleInputChange = event => {
        const value = event.target.value
        if (value.split('').every(char => !isNaN(parseInt(char)))) this.setState({ value: value })
    }

    handleBlur = () => {
        const newValue = Math.max(Math.min(this.state.value, this.props.maxValue), this.props.minValue)
        this.props.handleChange(newValue)

        this.updateInput()
    }

    handleKeyDown = event => {
        if (event.keyCode === KEY_CODES.ENTER || event.keyCode === KEY_CODES.ESCAPE) {
            this.input.blur()
            return
        }

        digitsOnlyKeyDownValidation(event)
    }

    render() {
        const { minValue, currentValue, maxValue } = this.props
        const selectionWidth = (currentValue - minValue) / (maxValue - minValue)

        return (
            <div className={styles.base}>
                <div className={styles.slider}>
                    <div className={styles.range}>
                        <div className={styles.holder}>
                            <div className={styles.selected} style={{ width: selectionWidth * 100 + '%' }} />
                            <div className={styles.wrapper}>
                                <input
                                    className={styles.input}
                                    type="range"
                                    min={minValue}
                                    value={currentValue}
                                    max={maxValue}
                                    onChange={this.handleSliderChange}
                                    onMouseEnter={sendHoverSoundCommand}
                                    onMouseDown={sendSelectClickSoundCommand}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={styles.limits}>
                        <span className={styles.limits_min}>
                            <FormattedNumber value={minValue} />
                        </span>
                        <span className={styles.limits_max}>
                            <FormattedNumber value={maxValue} />
                        </span>
                    </div>
                </div>
                <div className={styles.bet}>
                    <input
                        ref={c => this.input = c}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                        onKeyDown={this.handleKeyDown}
                        className={styles.bet_input}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]"
                        value={this.state.value}
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/TankAuctionSlider.jsx